"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _useAxios3 = _interopRequireDefault(require("./useAxios"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * @param {String} postalCodeInput- Post/Zip Code
 * @param {String} countryToUse - Country that will be used for API fetching.
 * postCode Hook to grab postCode data
 * @return api response data
 */
var usePostalCodeData = function usePostalCodeData(postalCodeInput) {
  var countryToUse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'NZ';
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    triggerApi = _useState2[0],
    setTriggerApi = _useState2[1];
  var initialState = {
    finalCityList: false,
    finalStateList: false,
    finalPostalCode: false,
    finalCountry: false,
    error: false,
    isLoading: false
  };
  var axiosRequestObject = {
    url: "/api/address/zipcode/".concat(countryToUse, "/").concat(postalCodeInput),
    method: 'get'
  };
  var _useState3 = (0, _react.useState)(initialState),
    _useState4 = _slicedToArray(_useState3, 2),
    postalCodeData = _useState4[0],
    setPostalCodeData = _useState4[1];
  var _useAxios = (0, _useAxios3["default"])([axiosRequestObject], triggerApi, setTriggerApi),
    _useAxios2 = _slicedToArray(_useAxios, 3),
    response = _useAxios2[0],
    error = _useAxios2[1],
    isLoading = _useAxios2[2];
  (0, _react.useEffect)(function () {
    if (postalCodeInput.length === 4) {
      setTriggerApi(true);
    } else if (postalCodeInput.length === 0) {
      setPostalCodeData(initialState);
    }
  }, [postalCodeInput]);
  (0, _react.useEffect)(function () {
    if (error && !isLoading) {
      setPostalCodeData(_objectSpread(_objectSpread({}, initialState), {}, {
        error: true
      }));
    }
  }, [error, isLoading]);
  (0, _react.useEffect)(function () {
    if (response && !isLoading) {
      var data = response.data.response;
      var zipCode = data.zipCode,
        stateList = data.stateList,
        cityList = data.cityList,
        country = data.country;
      setPostalCodeData(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          finalPostalCode: zipCode,
          finalStateList: stateList,
          finalCityList: cityList,
          finalCountry: country,
          error: false
        });
      });
    }
  }, [response, isLoading]);
  (0, _react.useEffect)(function () {
    if (triggerApi) {
      setPostalCodeData(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          isLoading: isLoading
        });
      });
    }
  }, [triggerApi, isLoading]);
  return postalCodeData;
};
var _default = exports["default"] = usePostalCodeData;